import React, { useEffect } from 'react'
import { PAGE_URL } from '../../constants'
import { navigate } from '../../router/redirections'
import { RouteAppComponentProps } from '../../router/routes'
import store from '../../store'
import { ActionType } from '../../store/home/action'
import { setPageTitle } from '../../utils/hook'
import AppErrorPageView from './view'

function AppErrorPage(props: RouteAppComponentProps): JSX.Element {
  useEffect(() => {
    setPageTitle(window)(props.pageName)()
  })
  useEffect(() => {
    store.dispatch({
      type: ActionType.SET_IS_LOADING,
      payload: { isLoading: false }
    })
  }, [])
  return (
    <AppErrorPageView
      onGoBackClick={() => props.history.goBack()}
      onGoDashboardClick={() => navigate(props.history)(PAGE_URL.HOME)}
    />
  )
}

export default AppErrorPage
